const ApiStore = require("stores/abstract/ApiStore");
const env = require("services/env");
const router = require("services/router");
const {reportAndThrow} = require("helpers/errors");

class BookingsStore extends ApiStore {
	getFee(id) {
		return axios
			.get(router.route("api.bookings.fee", {
				booking_id: id
			}))
			.then(response => {
				if (response.data && response.data.fee) return response.data.fee;
				throw "Got an invalid response";
			})
			.catch(reportAndThrow);
	}
}

module.exports = new BookingsStore(
	env.get("stores.bookings.collection", []),
	env.get("stores.bookings.constraints", {}),
	{},
	{endpoint: router.route("api.bookings.index")}
);



// WEBPACK FOOTER //
// ./resources/js/stores/BookingsStore.js